let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fZldR")).then(() => parcelRequire('1CbwT'));